import { Injectable } from '@angular/core';
import { ApiService } from './../Common/api.service';
import { UrlHelperService } from './../Common/urlhelper.service';
import {CustomFormValue} from './../../Model/CustomForm/customform.model'

@Injectable({
  providedIn: 'root'
})
export class CustomformService {

  constructor(private _api: ApiService) 
  { }

  SaveFormData(custom:CustomFormValue)
  {
    console.log(custom, "Inservice");
    return this._api.post(UrlHelperService.SaveCustomFormValue,custom);
  }

}
